import React, { ReactNode, RefObject, useRef } from 'react';
import { CardBase } from '@icarros/ids-react';
import { DroplistWrapper } from './style';

interface DroplistProps {
  handleCloseModal: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  children: ReactNode;
  wrapperRef: RefObject<HTMLDivElement>;
}

export function Droplist({
  handleCloseModal,
  children,
  wrapperRef
}: DroplistProps): React.JSX.Element {
  const droplistWrapperRef = useRef<HTMLDivElement>(null);
  const body = document.querySelector('body');
  body?.addEventListener('click', closeOnBodyClick);

  function closeOnBodyClick({ target }: MouseEvent) {
    const currentDiv = wrapperRef.current;
    const droplistWrapper = droplistWrapperRef.current;
    const element = target as HTMLElement;
    if (
      !currentDiv?.contains(element) ||
      currentDiv?.isSameNode(element) ||
      droplistWrapper?.isSameNode(element)
    ) {
      handleCloseModal(false);
      body?.removeEventListener('click', closeOnBodyClick);
    }
  }

  return (
    <DroplistWrapper ref={droplistWrapperRef}>
      <CardBase hasHover={false} variant="default" selected={false}>
        {children}
      </CardBase>
    </DroplistWrapper>
  );
}
